const getters = {
  products: state => state.all,
  product: state => state.product,
  destacados: state => state.destacados
}

export default getters
